import Rox from 'rox-browser';

export const FlagsShipmentBulk = {
  bulk_enable: new Rox.Flag(false),
};

export function initFlagsShipmentBulk() {
  // register flags with namespaces for better grouping
  Rox.register("featureShipmentBulk", FlagsShipmentBulk);
}
